import { render } from "./ViewDocumentClickSignComponent.vue?vue&type=template&id=64bb9e92&scoped=true"
import script from "./ViewDocumentClickSignComponent.vue?vue&type=script&lang=js"
export * from "./ViewDocumentClickSignComponent.vue?vue&type=script&lang=js"

import "./ViewDocumentClickSignComponent.vue?vue&type=style&index=0&id=64bb9e92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bb9e92"]])

export default __exports__